<template>
  <div class="flex flex-col gap-4">  
    <h2>{{ $t("Fleet.NewTitle") }}</h2>          
    <v-text-field hide-details  :label="$t('Fleet.Libelle')" v-model="fle_libelle" />      
    <v-select  hide-details  :items="fleetModes" item-text="libelle" item-value="value" :label="$t('Fleet.Type')"
        v-model="fleetType"
      ></v-select>
  </div>
</template>
<script lang="ts">


import Vue from 'vue'
import Component from 'vue-class-component'
import { FleetMode } from '@/enum/FleetMode'
import { FleetType } from '@/enum/FleetType'
import { getDefaultFleetIrisConfigCoverage } from '@/models/iris/fleet/IFleetIrisConfigCoverage'
import { getDefaultFleetIrisConfigFormation } from '@/models/iris/fleet/IFleetIrisConfigFormation'


  
@Component({
  name: 'FleetNew', 
})
export default class FleetNew extends Vue {      
    
  slugify = require('slugify')

  created() {               
    this.modified.ENS_ID = this.$store.myGetters.filterMission?.ensIds?.at(0) ?? this.$store.myGetters.userProfile.ensId
    this.modified.FLE_COMPANY = this.$store.myGetters.filterMission?.ensIds?.at(0)?this.$store.myGetters.enseignesById[this.modified.ENS_ID].ENS_KEY:this.$store.myGetters.userProfile.ensKey         
    this.modified.FLE_TYP = FleetType.FREE
    this.modified.FLE_LIBELLE = ""
  }
  
  get fleetType(){
    return this.modified.config?.fleet_type ?? FleetMode.FREE
  }

  set fleetType(value:FleetMode) {        
    if(value == FleetMode.PATHCOVERAGE) {
      this.modified.FLE_TYP = FleetType.COVERAGE   
      this.modified.config = getDefaultFleetIrisConfigCoverage()      
    }
    else if(value == FleetMode.KEEPFORMATION) {
      this.modified.FLE_TYP = FleetType.FORMATION    
      this.modified.config = getDefaultFleetIrisConfigFormation()
    }
    else if(value == FleetMode.FREE){
      this.modified.FLE_TYP = FleetType.FREE    
      this.modified.config = null
    } 
    
  }

 
  // BLF037 — seulement les types autorisés pour l'enseigne cible (RG-ACC-052).
  get fleetModes(){
    const allowed: FleetType[] = this.$store.myGetters.fleetTypesFor(this.modified.ENS_ID)
    return [      
      {libelle:this.$t('Fleet.Coverage'),value:FleetMode.PATHCOVERAGE,typ:FleetType.COVERAGE},
      {libelle:this.$t('Fleet.Formation'),value:FleetMode.KEEPFORMATION,typ:FleetType.FORMATION},
      {libelle:this.$t('Fleet.Free'),value:FleetMode.FREE,typ:FleetType.FREE}
    ].filter(mode => allowed.includes(mode.typ))
  }
  
  get modified(){
    return this.$store.myGetters.modifiedAdmAdminFleet
  }
    

  get fle_libelle(){
    return this.modified.FLE_LIBELLE!
  }

  set fle_libelle(value:string) {            
    this.$store.myActions.ADMINFLEET_UPDATE_MODIFIED_ADM({
      FLE_LIBELLE:value,
      FLE_NAME:this.slugify(value ?? '',{lower:true,replacement:'_',strict:true})
    })
  }

}

</script> 
